import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ChatbotFilterChipGroups } from '@/models/chatbot';
import useChatbotStore from '../store/useChatbotStore';
import { buildChatbotFilterChipGroups } from '../utils/buildChatbotFilterChips';

function useChatbotFilterHeader(): ChatbotFilterChipGroups | null {
  const { t } = useTranslation();
  const pinnedFilters = useChatbotStore(s => s.pinnedFilters);

  return useMemo(() => {
    if (!pinnedFilters) {
      return null;
    }

    const { globalFilters, localFilters } = buildChatbotFilterChipGroups(pinnedFilters, t);

    if (globalFilters.length === 0 && localFilters.length === 0) {
      return null;
    }

    return { globalFilters, localFilters };
  }, [pinnedFilters, t]);
}

export default useChatbotFilterHeader;
